import { render, staticRenderFns } from "./log-view-dialog.vue?vue&type=template&id=c55b7504&scoped=true&"
import script from "./log-view-dialog.vue?vue&type=script&lang=js&"
export * from "./log-view-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55b7504",
  null
  
)

export default component.exports